module.exports = __webpack_public_path__ + "assets/91373ea3f979cd6a8fd7a525f92c39c9.svg";